import { render } from "./Dashboard.vue?vue&type=template&id=39b27d12&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=39b27d12&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=39b27d12&lang=css"
script.render = render
script.__scopeId = "data-v-39b27d12"

export default script